<ion-item [ngClass]="{'lined': lines}" (click)="openModal()" *ngIf="!shadowInput">
  <ion-label position="floating">{{objectTypeTitle}}</ion-label>
  <ion-input type="text" [(ngModel)]="displayValue" [disabled]="disabled"></ion-input>
</ion-item>